package de.katoonerie.http

import com.apollographql.apollo3.api.http.HttpRequest
import com.apollographql.apollo3.api.http.HttpResponse
import com.apollographql.apollo3.network.http.HttpInterceptor
import com.apollographql.apollo3.network.http.HttpInterceptorChain

class DropHeadersInterceptor(private vararg val disallowedHeaders: String) :
    HttpInterceptor {
    override suspend fun intercept(request: HttpRequest, chain: HttpInterceptorChain): HttpResponse {
        val newRequest = request.newBuilder()
            .headers(request.headers.filter { it.name !in disallowedHeaders })
            .build()
        return chain.proceed(newRequest)
    }
}
